/**
 * Display label from Voluum tracker entity_WithDependencies.entity payload.
 * For Media Devoted | Created By Ciro Autiero
 */

export function pickVoluumTrackerEntityDisplayName(
  data: unknown,
): string {
  if (data === null || typeof data !== 'object') return '';
  const root = data as Record<string, unknown>;
  const entity = root.entity;
  if (entity === null || typeof entity !== 'object') return '';
  const e = entity as Record<string, unknown>;
  for (const key of ['namePostfix', 'name'] as const) {
    const v = e[key];
    if (typeof v === 'string' && v.trim().length > 0) return v.trim();
  }
  return '';
}
